import styled, { css } from "styled-components";

export const BaseLayoutRoot = styled.main(
    ({ theme }) => css`
        flex: 1;
        background: ${theme.palette.background};
        display: flex;
    `,
);
